export const ImageCard = ({ effect, file, index }) => {
  return (
    <img
      data-aos={"fade-" + effect}
      data-aos-duration="1250"
      data-aos-delay={150 + 100 * index}
      src={"/assets/img/lions-cards/" + file + ".png"}
      alt={file + " Lion"}
    />
  );
};

export const PhaseCard = ({ title, content }) => {
  const describe = content.map((line, index) => {
    return (
      <span key={index}>
        {line}
        <br />
      </span>
    );
  });
  return (
    <div className="col-12 col-lg-8 timeline__event__content">
      <h4 className="timeline__event__title">{title}</h4>
      <p>{describe}</p>
    </div>
  );
};

export const WorkCard = ({ title, text, children }) => {
  return (
    <div className="col-12 col-md-6 pre-mint">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">{title}</h3>
          <h5 className="text-white-50 card-subtitle mb-4">{text}</h5>
          {children}
        </div>
      </div>
    </div>
  );
};